import { boolean, object, optional, string } from 'superstruct';

export const careFinderConfigSchema = object({
  careFinderSearchInitiationRootNodeId: optional(string()),
  careFinderSearchResultsRootNodeId: optional(string()),
  careFinderProviderDetailsRootNodeId: optional(string()),
  careFinderFacilityDetailsRootNodeId: optional(string()),
  schedulingEnabled: optional(boolean()),
  schedulingServiceSelectionRootNodeId: optional(string()),
  schedulingAvailabilityRootNodeId: optional(string()),
  schedulingReviewRootNodeId: optional(string()),
  schedulingConfirmationRootNodeId: optional(string()),
  schedulingAppointmentDetailRootNodeId: optional(string()),
});
